import { call, put, takeLatest } from 'redux-saga/effects'
import { navigate } from '@reach/router'
import * as emp501Api from '../apiModules/emp501'
import * as emp501Module from '../modules/emp501'

function* generateEmp501File({ payload }) {
  try {
    navigate('/dashboard/bulk-actions?generateEMP501Request=in-progress')
    const response = yield call(emp501Api.generateEmp501File, payload)

    // Extract file data from response
    const { fileName, content, mimeType = 'text/plain' } = response.data

    // Create a blob from the content string
    const blob = new Blob([content], { type: mimeType })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()

    // Cleanup
    link.parentNode.removeChild(link)
    window.URL.revokeObjectURL(url)

    yield put(emp501Module.generateEmp501FileSuccess())

    // Navigate to success page
    return navigate('/dashboard/bulk-actions?generateEMP501Request=success')
  } catch (err) {
    yield put(emp501Module.generateEmp501FileFailure((err.response && err.response.data) || err))

    // Navigate to error page
    return navigate('/dashboard/bulk-actions?generateEMP501Request=error')
  }
}

export const emp501Sagas = [takeLatest(emp501Module.GENERATE_EMP501_FILE, generateEmp501File)]
